import { useTranslation } from "react-i18next";

import PortfolioCard from "../../components/PortfolioCard/PortfolioCard";

import "./Portfolio.css";

const Portfolio = ({ innerRef }) => {
	const { t } = useTranslation();
	const items = t("portfolio.featured", { returnObjects: true });

	return (
		<div id="home-portfolio" ref={innerRef} className="portfolio-bg">
			<h2 className="portfolio-title">{t("portfolio.title")}</h2>

			<div className="portfolio-container">
				{items.map((item, index) => (
					<PortfolioCard
						key={index}
						data={{
							id: index + 1,
							title: item["title"],
							subtitle: item["subtitle"],
							description: item["description"],
							type: item["type"],
							image: item["imageFixed"],
							alt: item["altFixed"],
						}}
					/>
				))}
			</div>
		</div>
	);
};

export default Portfolio;
